module.exports = __webpack_public_path__ + "static/media/sticker-web.967cd45a.png";